import dayjs from 'dayjs'
import { create } from 'zustand'
import { getLastCompleteDate } from '@/lib/date-utils'

// Local date picker store for Day0 ROAS page
export const useDay0RoasDatePicker = create((set) => {
  const lastCompleteDate = getLastCompleteDate(true)
  return {
    startDate: dayjs(lastCompleteDate.toString())
      .subtract(6, 'day')
      .format('YYYYMMDD'),
    endDate: lastCompleteDate.toString(),
    allowIncomplete: false,
    updateStartDate: (startDate) => set({ startDate }),
    updateEndDate: (endDate) => set({ endDate }),
    setAllowIncomplete: (allowIncomplete) => set({ allowIncomplete }),
  }
})
